import React from 'react';
import LegalDocument from './LegalDocument';
import { cookiePolicy } from '../content/legalTexts';
import LegalCompanyDetails from './LegalCompanyDetails';

function CookiesPolicy() {
  return (
    <section className="faq terms-nd-condition">
      <div className="container">
        <LegalDocument doc={cookiePolicy} />
        <LegalCompanyDetails />
      </div>
    </section>
  );
}

export default CookiesPolicy;
